var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
export default (function (studentId, input) { return ({
    mutation: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation updateContactPersonNameMutation(\n      $input: UpdateContactPersonNameInput!\n    ) {\n      updateContactPersonName(input: $input) {\n        viewerAgent {\n          id\n          contactPersonName\n        }\n      }\n    }\n  "], ["\n    mutation updateContactPersonNameMutation(\n      $input: UpdateContactPersonNameInput!\n    ) {\n      updateContactPersonName(input: $input) {\n        viewerAgent {\n          id\n          contactPersonName\n        }\n      }\n    }\n  "]))),
    variables: { input: input },
    optimisticResponse: {
        updateContactPersonName: {
            __typename: "UpdateContactPersonNameOutput",
            viewerAgent: {
                __typename: "Agent",
                id: studentId,
                contactPersonName: input.contactPersonName,
            },
        },
    },
}); });
var templateObject_1;
